import React, { Fragment, useEffect, useState } from 'react';
import { withTranslation } from 'react-i18next';
import PropTypes from 'prop-types';

const BottomBarInfos = (props) => {
  const {
    t,
    amountReceived,
    expired,
    receiving,
    selectedItems,
    numberOfRecords,
  } = props;

  const [selectedItemsValue, setSelectedItemsValue] = useState('');

  useEffect(() => {
    const totalValue = selectedItems.reduce(
      (total, item) => total + item.value,
      0
    );
    setSelectedItemsValue(
      totalValue.toLocaleString('pt-br', { style: 'currency', currency: 'BRL' })
    );
  }, [selectedItems]);

  return (
    <Fragment>
      <div className="form__form-group--3_columns mt-4 mb-0">
        <div className="form__form-group d-flex">
          <span className="form__form-group-label">
            {t('general.received')}
          </span>
          <span className="ml-2 text-success ">{amountReceived}</span>
        </div>
        <div className="form__form-group d-flex mb-2">
          <span className="form__form-group-label">
            {t('general.unsuccessful')}
          </span>
          <span className="ml-2 text-danger ">{expired}</span>
        </div>
        <div className="form__form-group d-flex">
          <span className="form__form-group-label">
            {t('general.selected-releases')}
          </span>
          <span className="ml-2">{selectedItems.length}</span>
        </div>
      </div>
      <div className="form__form-group--3_columns">
        <div className="form__form-group d-flex flex-wrap mb-0">
          <span className="form__form-group-label text-nowrap">
            {t('general.receiving')}
          </span>
          <span className="ml-2 text-primary ">{receiving}</span>
        </div>
        <div className="form__form-group d-flex flex-wrap mb-0">
          <span className="form__form-group-label text-nowrap">
            {t('general.number-of-releases')}
          </span>
          <span className="ml-2">{numberOfRecords}</span>
        </div>
        <div className="form__form-group d-flex mb-0">
          <span className="form__form-group-label text-nowrap">
            {t('general.total-selected-launches')}
          </span>
          <span className="ml-1">{selectedItemsValue}</span>
        </div>
      </div>
    </Fragment>
  );
};

BottomBarInfos.propTypes = {
  t: PropTypes.func.isRequired,
  expired: PropTypes.string,
  receiving: PropTypes.string,
  amountReceived: PropTypes.string,
  numberOfRecords: PropTypes.number,
  selectedItems: PropTypes.arrayOf(PropTypes.shape),
};

BottomBarInfos.defaultProps = {
  expired: '',
  receiving: '',
  amountReceived: '',
  numberOfRecords: 0,
  selectedItems: [],
};

export default withTranslation('common')(BottomBarInfos);
